import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Card, CardBody, Col, Modal, ModalBody, Row } from "reactstrap";

import Pagination from "../../Jobs/JobList2/Pagination";

//Import Images
import jobImage1 from "../../../assets/images/featured-job/img-01.png";
import jobImage2 from "../../../assets/images/featured-job/img-02.png";
import jobImage3 from "../../../assets/images/featured-job/img-03.png";
import jobImage4 from "../../../assets/images/featured-job/img-04.png";
import jobImage5 from "../../../assets/images/featured-job/img-05.png";
import jobImage6 from "../../../assets/images/featured-job/img-06.png";
import { del, get } from "../../../utils/apiUtil";

const JobListing = () => {
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteJobID, setDeleteJobID] = useState(null);
    const [jobs, setJobs] = useState([]);
    const openModal = () => setModal(!modal);

    const [showError, setShowError] = useState(false);
    const getAllJobs = async () => {
        setIsLoading(true);
        try {
            const response = await get('/get-all-jobs');
            setJobs(response.data);
        } catch (error) {
            if (error.status === 404) {
                setShowError(true);
            } else {
                alert(error?.message || "Something went wrong.");
            }
        } finally {
            setIsLoading(false);
        }
    }

    const getJobsByType = (jobType) => {
        return jobs?.filter(job => job.JobType.toLowerCase() === jobType.toLowerCase());
    };

    const fallbackImage = "https://t4.ftcdn.net/jpg/06/71/92/37/360_F_671923740_x0zOL3OIuUAnSF6sr7PuznCI5bQFKhI0.jpg";
    const badgeClassPool = [
        { bg: "bg-primary-subtle", text: "text-primary" },
        { bg: "bg-success-subtle", text: "text-success" },
        { bg: "bg-danger-subtle", text: "text-danger" },
        { bg: "bg-warning-subtle", text: "text-warning" },
        { bg: "bg-info-subtle", text: "text-info" },
        { bg: "bg-secondary-subtle", text: "text-secondary" }
    ];

    const getColorClassForSkill = (skill) => {
        const hash = [...skill].reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const index = hash % badgeClassPool.length;
        return badgeClassPool[index];
    };

    const transformedJobsObject = (jobType = null, limit = null) => {
        let filteredJobs = jobType
            ? getJobsByType(jobType)
            : jobs;

        if (limit && Number.isInteger(limit)) {
            filteredJobs = filteredJobs.slice(0, limit);
        }

        return filteredJobs.map((job, index) => {
            return {
                ID: job.ID,
                companyImg: job.CompanyLogo || fallbackImage,
                jobDescription: job.JobTitle || "Untitled Job",
                companyName: job.CompanyName || "Matrix Executive Search Group",
                location: job.JobLocation || "Not specified",
                salary: job.OfferSalary || "Negotiable",
                fullTime: job.JobType?.toLowerCase() === "full time",
                partTime: job.JobType?.toLowerCase() === "part time",
                freelancer: job.JobType?.toLowerCase() === "freelancer",
                timing: job.JobType || "Unknown",
                catogary: job.JobType || "",
                addclassNameBookmark: job.Featured || false,
                badges: job.SkillTags
                    ? job.SkillTags.split("|").map((skill, index) => {
                        const colorClass = getColorClassForSkill(skill);
                        return {
                            id: index,
                            badgeclassName: `${colorClass.bg} ${colorClass.text}`,
                            badgeName: skill.trim()
                        };
                    })
                    : [],
                experience: job.ExperienceRequired || "0 - 1 years",
                Notes:
                    job.JobDescription && job.JobDescription.length > 40
                        ? job.JobDescription.slice(0, 60) + "..."
                        : job.JobDescription || null
            };
        });
    };

    useEffect(() => {
        getAllJobs();
    }, []);

    const handleDelete = async () => {
        setIsLoading(true);
        try {
            const response = await del('/delete-job', { params: { jobID: deleteJobID } });
            if (response.status === 200) {
                openModal();
                getAllJobs();
            } else {
                throw new Error(response?.message || 'Something went wrong');
            }
        } catch (error) {
            alert(error?.message || 'An error occurred while deleting job.');
        }
    };

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    {showError ? <Alert color="danger" style={{ marginTop: '40px' }}>No jobs found.</Alert> : (
                        transformedJobsObject("", "").map((jobListingDetails, key) => (
                            <Card className="job-box card mt-4" key={key}>
                                <CardBody className="p-4">
                                    <Row>
                                        <Col lg={1}>
                                            <Link to="/companydetails">
                                                <img
                                                    src={jobListingDetails.companyImg}
                                                    alt=""
                                                    className="img-fluid rounded-3"
                                                />
                                            </Link>
                                        </Col>

                                        <Col lg={9}>
                                            <div className="mt-3 mt-lg-0">
                                                <h5 className="fs-17 mb-2">
                                                    <Link to={`/job-details/${jobListingDetails.ID}`} className="text-dark">
                                                        {jobListingDetails.jobDescription}
                                                    </Link>
                                                </h5>
                                                <ul className="list-inline mb-0">
                                                    <li className="list-inline-item">
                                                        <p className="text-muted fs-14 mb-0">
                                                            {jobListingDetails.companyName}
                                                        </p>
                                                    </li>
                                                    <li className="list-inline-item mx-4">
                                                        <p className="text-muted fs-14 mb-0">
                                                            <i className="mdi mdi-map-marker"></i>{" "}
                                                            {jobListingDetails.location}
                                                        </p>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <p className="text-muted fs-14 mb-0 mx-4">
                                                            <i className="uil uil-wallet"></i>{" "}
                                                            ${jobListingDetails.salary}
                                                        </p>
                                                    </li>
                                                </ul>
                                                <div className="mt-2">
                                                    {/* <span
                                                    className={
                                                        jobListingDetails.fullTime === true
                                                            ? "badge bg-success-subtle text-success fs-13 mt-1 mx-1"
                                                            : jobListingDetails.partTime === true
                                                                ? "badge bg-danger-subtle text-danger fs-13 mt-1 mx-1"
                                                                : jobListingDetails.freeLance === true
                                                                    ? "badge bg-primary-subtle text-primary fs-13 mt-1 mx-1"
                                                                    : jobListingDetails.internship === true
                                                                        ? "badge bg-info-subtle text-info fs-13 mt-1"
                                                                        : ""
                                                    }
                                                >
                                                    {jobListingDetails.timing}
                                                </span> */}
                                                    {(jobListingDetails.badges || []).map(
                                                        (badgeInner, key) => (
                                                            <span
                                                                className={`badge ${badgeInner.badgeclassName} fs-13 mt-1 mx-1`}
                                                                key={key}
                                                            >
                                                                {badgeInner.badgeName}
                                                            </span>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        </Col>

                                        <Col lg={2} className="align-self-center">
                                            <ul className="list-inline mt-3 mb-0">
                                                <li
                                                    className="list-inline-item"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Edit"
                                                >
                                                    <Link
                                                        to="/post-a-job"
                                                        state={{ jobData: jobs.find(job => job.ID === jobListingDetails.ID) }}
                                                        className="avatar-sm bg-success-subtle text-success d-inline-block text-center rounded-circle fs-18"
                                                    >
                                                        <i className="uil uil-edit"></i>
                                                    </Link>
                                                </li>
                                                <li
                                                    className="list-inline-item"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Delete"
                                                >
                                                    <Link
                                                        onClick={() => { setDeleteJobID(jobListingDetails.ID); openModal() }}
                                                        to="#"
                                                        className="avatar-sm bg-danger-subtle text-danger d-inline-block text-center rounded-circle fs-18"
                                                    >
                                                        <i className="uil uil-trash-alt"></i>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        ))
                    )}
                </Col>
                {!showError && <Pagination />}
            </Row>

            <div
                className="modal fade"
                id="deleteModal"
                tabIndex="-1"
                aria-labelledby="deleteModal"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <Modal isOpen={modal} toggle={openModal} centered tabIndex="-1">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel">
                                Delete Jobs ?
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <ModalBody>
                            <div>
                                <h6 className="text-danger">
                                    <i className="uil uil-exclamation-triangle"></i> Warning: Are you sure you want to delete job Post ?
                                </h6>
                                <p className="text-muted">
                                    {" "}
                                    Your jobs post will be permenently removed and you won't be
                                    able to see them again, including the once you're shared with
                                    your friends.
                                </p>
                            </div>
                        </ModalBody>
                        <div className="modal-footer">
                            <button
                                type="button"
                                onClick={openModal}
                                className="btn btn-primary btn-sm"
                            >
                                Cancel
                            </button>
                            <button type="button" className="btn btn-danger btn-sm" onClick={handleDelete}>
                                Yes, delete
                            </button>
                        </div>
                    </Modal>
                </div>
            </div>
        </React.Fragment>
    );
};

export default JobListing;
